import { render } from "./weeklyArticleDetail1.vue?vue&type=template&id=2749f90e&scoped=true"
import script from "./weeklyArticleDetail1.vue?vue&type=script&lang=js"
export * from "./weeklyArticleDetail1.vue?vue&type=script&lang=js"

import "./weeklyArticleDetail1.vue?vue&type=style&index=0&id=2749f90e&lang=scss&scoped=true"
import "./weeklyArticleDetail1.vue?vue&type=style&index=1&id=2749f90e&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2749f90e"]])

export default __exports__